module.exports = __webpack_public_path__ + "media/images/book-img-06-c5af25a9b49811520ae329d1c4e942c6.png";